import { Office } from '../post-office/office';

export namespace AddressBook {
  export class Result {
    public id: number;
    public postcode: string;
    public region: string;
    public district: string;
    public city_type: string;
    public city: string;
    public street_type: string;
    public address_type: string;
    public cell_number: string;
    public street: string;
    public buildings: string;
    public building_map: Array<{
      building: number;
      housings: (string | null)[];
    }>;
    public is_district_center: boolean;
    public building: string;
    public flat: string;
    public created_at: string;
    public updated_at: string;
    public address: string;
    public autocomplete_address: string;
    public short_address: string;
    public ops?: Office;
    public postcode_id: number;
    public house: string;

    constructor(data: Result) {
      Object.assign(this, data);
      this.buildings = data.buildings
        ? data.buildings.split(',').join(', ')
        : data.buildings;
    }
  }

  export class ElasticSearchResult {
    public ops: any[];
    public postcodes: Result[];

    constructor(data: ElasticSearchResult) {
      Object.assign(this, data);
      this.postcodes = data.postcodes.map((p) => new Result(p));
    }
  }
}
